var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BBadge,{attrs:{"variant":_setup.variant}},[(_setup.props.included)?_c(_setup.FontAwesomeIcon,{attrs:{"icon":"check"}}):_c(_setup.FontAwesomeIcon,{attrs:{"icon":"times"}}),_vm._v("\n    "+_vm._s(_setup.props.itemName)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }